module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/bg_equipment_sp-30fcd794ca48c065ba25059bca1d104d.png";